export enum CloudTypes {
  AWS = 'AWS',
}